import { React, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import TodayIcon from "@mui/icons-material/Today";
import CasinoIcon from "@mui/icons-material/Casino";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import QueueIcon from "@mui/icons-material/Queue";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { useNavigate } from "react-router-dom";

export default function Menu() {
	const navigate = useNavigate();
	const [open, setOpen] = useState(false);

	const toggleDrawer = (newOpen) => () => {
		setOpen(newOpen);
	};

	const pages = [
		{ name: "Menu Planner", path: "/mealPlanner", icon: <TodayIcon /> },
		{ name: "Dish Roulette", path: "/dishRoulette", icon: <CasinoIcon /> },
		{ name: "Request Function", path: "#", icon: <TipsAndUpdatesIcon /> },
		{ name: "Add Recepie", path: "/addRecipe", icon: <QueueIcon /> },
		{
			name: "All Recepies",
			path:
				"https://romantic-handsaw-ad8.notion.site/6f58a84c20d041059f1388254072bf2a?v=9010154efc614d4fb7de72e6386ce1e3&pvs=74",
			icon: <ListAltIcon />,
		},
	];
	function handleMenuClick(route) {
		if (route.startsWith("http://") || route.startsWith("https://")) {
			// External link → open in a new tab
			window.open(route, "_blank", "noopener,noreferrer");
		} else {
			// Internal route → use React Router
			navigate(route);
		}
	}

	const DrawerList = (
		<Box
			sx={{ width: 250, paddingTop: 20 }}
			role="presentation"
			onClick={toggleDrawer(false)}
		>
			<List>
				{pages.map(({ name, path, icon }, index) => (
					<ListItem key={name} disablePadding>
						<ListItemButton
							onClick={() => {
								handleMenuClick(path);
							}}
						>
							<ListItemIcon>{icon}</ListItemIcon>
							<ListItemText primary={name} />
						</ListItemButton>
					</ListItem>
				))}
			</List>
			<Divider />
			{/* <List>
				{["All mail", "Trash", "Spam"].map((text, index) => (
					<ListItem key={text} disablePadding>
						<ListItemButton>
							<ListItemIcon>
								{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
							</ListItemIcon>
							<ListItemText primary={text} />
						</ListItemButton>
					</ListItem>
				))}
			</List> */}
		</Box>
	);

	return (
		<div style={{ position: "relative", zIndex: 10 }}>
			<Button
				sx={{
					position: "absolute",
					top: 16,
					left: 16,
					zIndex: 2000, // Make sure it's on top
				}}
				onClick={toggleDrawer(true)}
			>
				Menu
			</Button>
			<Drawer open={open} onClose={toggleDrawer(false)}>
				{DrawerList}
			</Drawer>
		</div>
	);
}
